var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-mobile"},[_c('div',{staticClass:"container-mobile"},[_c('img',{staticClass:"quit-btn",attrs:{"src":require("../../assets/image/back-img.png")},on:{"click":_vm.handleBackClick}}),_c('div',{ref:"chat",staticClass:"chat-mobile",on:{"enter-fail":_vm.enterFail}},[_c('NewChat')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }